import PlaceholderPage from '../components/PlaceholderPage';

export default function Naits() {
  return (
    <PlaceholderPage
      title="NAITS"
      description="The National Animal Identification and Traceability System page lands here."
    />
  );
}
